import { render, staticRenderFns } from "./AnalyticsPage.vue?vue&type=template&id=70bbec6d&scoped=true&"
import script from "./AnalyticsPage.vue?vue&type=script&lang=js&"
export * from "./AnalyticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bbec6d",
  null
  
)

export default component.exports